import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose } from 'recompose'

import withReduxModal from '../../../modules/redux-modal/redux/withReduxModal'
import { TOWN_BANNER_ITEM_MODAL } from '../../../constants/modalType'
import { initBanners } from '../../../actions/banners'

const BannerListActionPanel = ({ modalActions, actions }) => (
  <div className="has-text-right">
    <a
      className="button is-primary"
      onClick={() => {
        actions.initBanners()
        modalActions.showModal(TOWN_BANNER_ITEM_MODAL, { bannerID: 'TEMP_ID' })
      }}
    >
      <span className="icon">
        <i className="fas fa-plus" aria-hidden="true" />
      </span>
      <span>
        <strong> Create </strong>
      </span>
    </a>
  </div>
)

export default compose(
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators({ initBanners: initBanners }, dispatch),
    }),
  ),
  withReduxModal,
)(BannerListActionPanel)



// WEBPACK FOOTER //
// ./src/components/templates/banner-list/BannerListActionPanel.js